import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { CONTENT_PAGE_ROUTES, DNA_APP_ROUTES } from '../config/routes'

const Home = lazy(() => import("./pages/home"))
const Pages = lazy(() => import('./Pages'))
const DnaRouteView = lazy(() => import('../apps/dna/DnaRouteView'))


function AppRouter() {
    return (
        <Router>
          <Suspense fallback={<div className="App" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              {CONTENT_PAGE_ROUTES.map(({ path, type }) => (
                <Route key={path} path={path} element={<Pages type={type} />} />
              ))}
              {DNA_APP_ROUTES.map(({ path, type }) => (
                <Route key={path} path={path} element={<DnaRouteView routeType={type} />} />
              ))}
            </Routes>
          </Suspense>
        </Router>
      )
}

export default AppRouter
